<template>
  <!-- Table Container Card -->
  <b-card no-body>
    <div class="m-2">
      <!-- Table Top -->
      <b-row>
        <!-- Per Page -->
        <b-col
          cols="4"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Show</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block mx-50"
          />
          <label>entries</label>
        </b-col>

        <!-- Search -->
        <b-col cols="8">
          <div class="d-flex align-items-center justify-content-end">
            <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              placeholder="Search..."
            />
            <v-select
              v-model="statusFilter"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusOptions"
              class="address-filter-select mr-1"
              placeholder="Select Status"
            >
              <template #selected-option="{ label }">
                <span class="text-truncate overflow-hidden">
                  {{ label }}
                </span>
              </template>
            </v-select>
            <b-button variant="primary">
              <span class="text-nowrap">Add Address</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-table
      responsive
      show-empty
      :empty-text="$t('HomePage.NoMatching')"
      class="position-relative"
      :per-page="perPage"
      :current-page="currentPage"
      :fields="tableColumns"
      :items="userAddressList"
      :filter="searchQuery"
      :filter-included-fields="filterOn"
      @filtered="onFiltered"
    >
      <!-- <template #cell(id)="data">
        <b-link
          :to="{ name: 'apps-address-preview', params: { id: data.item.id }}"
          class="font-weight-bold"
        >
          #{{ data.value }}
        </b-link>
      </template> -->

      <template #cell(status)="data">
        <b-badge
          pill
          :variant="`light-${resolveAddressrStatusVariant(data.item.status)}`"
          class="text-capitalize"
        >
          {{ data.item.status }}
        </b-badge>
      </template>
    </b-table>

    <div class="mx-2 mb-2">
      <b-row>
        <!-- <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
        </b-col> -->

        <!-- Pagination -->
        <b-col
          cols="12"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          />
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BLink,
  BBadge,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ref } from "@vue/composition-api";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BBadge,
    BPagination,

    vSelect,
  },
  props: {
    userAddressList: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const statusOptions = ["pending", "active", "inactive"];

    // Table Handlers
    const tableColumns = [
      { key: "id", label: "No.", sortable: true },
      { key: "fullName", label: "FULL NAME", sortable: true },
      { key: "addressDetail", label: "ADDRESS INFORMATION", sortable: true },
      { key: "mobile", label: "MOBILE", sortable: true },
      { key: "status", label: "STATUS", sortable: true },
    ];
    const perPage = ref(3);
    const totalRows = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [3, 5, 10];
    const searchQuery = ref("");
    const filterOn = ref([]);
    const statusFilter = ref(null);

    totalRows.value = props.userAddressList.length;

    const resolveAddressrStatusVariant = (status) => {
      if (status === "pending") return "warning";
      if (status === "active") return "success";
      if (status === "inactive") return "secondary";
      return "primary";
    };

    return {
      tableColumns,
      perPage,
      currentPage,
      totalRows,
      // dataMeta,
      perPageOptions,
      searchQuery,
      filterOn,
      statusFilter,
      resolveAddressrStatusVariant,
      statusOptions,
      // avatarText,
    };
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.address-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
